if (!customElements.get("custom-form")) {
    customElements.define(
      "custom-form",
      class CustomForm extends HTMLElement {
        constructor() {
          super();   
          
          
        }
  
        connectedCallback() {
            this.form = this.closest("form");

            const showOrHideFields = () => {
                this.fields = [...this.querySelectorAll("[data-field-block-id]")];

                this.fields.forEach(field1 => {
                    const showWhen = field1.dataset.showWhen.split(", ");
                    
                    if(showWhen.length < 1 || showWhen[0] === "") return;
                    
                    let shouldBeShown = false;
                    
                    // array of arrays with the id and value of the field to show when
                    const showWhen2 = showWhen.map(item => {
                        return item.replace("]", "").split("[").map(item => item.trim());
                    })


                    // if the field is in the showWhen2 array, then it should be shown
                    for(const element of showWhen2) {
                        const findElement = this.querySelector(`[data-field-block-id="${element[0]}"]`);
                        if(findElement) {
                            if(findElement.querySelector("input")?.value?.trim() === element[1].trim() || findElement.querySelector("select")?.value?.trim() === element[1].trim()) {
                                shouldBeShown = true;
                            }
                        }
                    }

                    // show or hide the field
                    if(shouldBeShown) {
                        if(field1.classList.contains("form__field--checkbox")){
                            field1.style.display = "flex"
                        } else {
                            field1.style.display = "block";
                        }
                    } else {
                        field1.style.display = "none";
                        field1.disabled = true;
                        const input = field1.querySelector("input");
                        const select = field1.querySelector("select");
                        if(input) input.value = "";
                        if(select) select.value = "";
                    }
                })
            }

            showOrHideFields();

            this.form.addEventListener("change", () => {
                showOrHideFields();
            });
        }
  

      },
    );
  }
  